const BtnSpinner: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="spinner"
      {...props}
    >
      <path
        d="M9.94603 4.67856C11.1734 4.67856 12.1684 3.63123 12.1684 2.33928C12.1684 1.04733 11.1734 0 9.94603 0C8.71863 0 7.72363 1.04733 7.72363 2.33928C7.72363 3.63123 8.71863 4.67856 9.94603 4.67856Z"
        fill={props.fill || "white"}
      />
      <path
        d="M9.9456 19.9999C10.682 19.9999 11.2789 19.3716 11.2789 18.5965C11.2789 17.8214 10.682 17.1931 9.9456 17.1931C9.20924 17.1931 8.6123 17.8214 8.6123 18.5965C8.6123 19.3716 9.20924 19.9999 9.9456 19.9999Z"
        fill={props.fill || "white"}
      />
      <path
        d="M4.48468 6.82502C5.58942 6.82502 6.48498 5.88235 6.48498 4.71952C6.48498 3.55668 5.58942 2.61401 4.48468 2.61401C3.37994 2.61401 2.48438 3.55668 2.48438 4.71952C2.48438 5.88235 3.37994 6.82502 4.48468 6.82502Z"
        fill={props.fill || "white"}
      />
      <path
        d="M15.4061 17.3844C16.0198 17.3844 16.5173 16.8608 16.5173 16.2148C16.5173 15.5688 16.0198 15.0452 15.4061 15.0452C14.7924 15.0452 14.2949 15.5688 14.2949 16.2148C14.2949 16.8608 14.7924 17.3844 15.4061 17.3844Z"
        fill={props.fill || "white"}
      />
      <path
        d="M2.2228 12.3393C3.20448 12.3393 4.00029 11.5017 4.00029 10.4684C4.00029 9.43507 3.20448 8.59741 2.2228 8.59741C1.24112 8.59741 0.445312 9.43507 0.445312 10.4684C0.445312 11.5017 1.24112 12.3393 2.2228 12.3393Z"
        fill={props.fill || "white"}
      />
      <path
        d="M17.6677 11.4027C18.1583 11.4027 18.5561 10.984 18.5561 10.4676C18.5561 9.95113 18.1583 9.53247 17.6677 9.53247C17.177 9.53247 16.7793 9.95113 16.7793 10.4676C16.7793 10.984 17.177 11.4027 17.6677 11.4027Z"
        fill={props.fill || "white"}
      />
      <path
        d="M3.3856 15.0589C2.77772 15.6988 2.77772 16.734 3.3856 17.3739C3.99275 18.0137 4.97776 18.0137 5.58492 17.3739C6.1928 16.734 6.1928 15.6988 5.58492 15.0589C4.97776 14.4183 3.99348 14.4122 3.3856 15.0589Z"
        fill={props.fill || "white"}
      />
      <path
        d="M15.4055 5.42097C15.7735 5.42097 16.0718 5.10697 16.0718 4.71964C16.0718 4.33231 15.7735 4.01831 15.4055 4.01831C15.0376 4.01831 14.7393 4.33231 14.7393 4.71964C14.7393 5.10697 15.0376 5.42097 15.4055 5.42097Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
};

export default BtnSpinner;
